import { useQueryGetAllGroups } from 'lib/api/superadmin/landingPageDesignGroups/useQueryGetAllGroups';
import { MultiselectDropdown } from 'lib/components/dropdown/MultiselectDropdown';
import { Flex } from 'lib/components/styles/layout';
import React from 'react';
import { IGroupOption, ILandingPageDesignGroup } from '../types';
import { Search } from 'lib/components';

interface LandingPageGroupFiltersProps {
  searchQuery: string;
  onGroupSearchHandler: (value: string) => void;
  setSelectedGroups: React.Dispatch<React.SetStateAction<(string | number)[]>>;
  isFetchingFilteredGroups: boolean;
}

export const LandingPageGroupFilters = ({
  searchQuery,
  onGroupSearchHandler,
  setSelectedGroups,
  isFetchingFilteredGroups,
}: LandingPageGroupFiltersProps) => {
  const { data: groups, isFetching: isFetchingGroups } = useQueryGetAllGroups();
  const groupOptions: IGroupOption[] = groups
    ? Array.from(
        new Map(
          groups.map((group: ILandingPageDesignGroup) => [
            group.landingPageDesignGroupId,
            {
              label: `${group.title} - ${group.landingPageDesignGroupId}`,
              value: group.landingPageDesignGroupId,
            } as IGroupOption,
          ])
        ).values()
      )
    : [];
  const isDisabled = isFetchingGroups || isFetchingFilteredGroups;

  return (
    <Flex flexDirection='row' width='100%' gap='10px'>
      <MultiselectDropdown
        onOptionsSelected={setSelectedGroups}
        options={groupOptions}
        menuListValue={-1}
        menuListLabel='All Groups'
        isClearable
        isSearchable
        name='group'
        menuShouldBlockScroll={false}
        isDisabled={isDisabled}
        isLoading={isFetchingGroups}
        selectInputWidth='200px'
        menuWidth='250px'
        zIndex={1}
      />
      <Search
        onSearch={onGroupSearchHandler}
        prevSearch={searchQuery}
        placeholder='Search by group or landing page…'
        disabled={isDisabled}
      />
    </Flex>
  );
};
